/**
 * @license @tabler/icons-react v3.30.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBrandGoogle = createReactComponent("outline", "brand-google", "IconBrandGoogle", [["path", { "d": "M20.945 11a9 9 0 1 1 -3.284 -5.997l-2.655 2.392a5.5 5.5 0 1 0 2.119 6.605h-4.125v-3h7.945z", "key": "svg-0" }]]);

export { IconBrandGoogle as default };
//# sourceMappingURL=IconBrandGoogle.mjs.map
